export const EINREICHUNG_STORE_KEY = 'einreichung-new';
